import "./listaSensores.css";
import * as React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses  } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Fab from '@mui/material/Fab';



function createData(name, localizacao, status) {
    return {
      name,
      localizacao,
      status,
      history: [
        {
          date: '2021-10-02',
          temperatura: '12.3 Hz',
          umidade: '27 %',
          gases: '45 MM',
          vento: '2 µs'
        },
        {
            date: '2021-10-01',
            temperatura: '12 Hz',
            umidade: '25 %',
            gases: '40 MM',
            vento: '1.7 µs'
        },
        {
            date: '2021-09-30',
            temperatura: '10.5 Hz',
            umidade: '16 %',
            gases: '30 MM',
            vento: '1.3 µs'
        },
      ],
    };
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: '#696A67',
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));

function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.name}
        </TableCell>
        <TableCell align="right">{row.localizacao}</TableCell>
        <TableCell align="right">{row.status}</TableCell>
        <TableCell align="right">
            <Fab variant="extended" size="small" color='#DAF7A6' aria-label="add">
                DETAILS
            </Fab>
        </TableCell>

      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
              INDIVIDUAL DATA
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>DATA</TableCell>
                    <TableCell>INFRASOUND</TableCell>
                    <TableCell align="right">SOIL</TableCell>
                    <TableCell align="right">RAIN</TableCell>
                    <TableCell align="right">GROUND MOVEMENT</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.history.map((historyRow) => (
                    <TableRow key={historyRow.date}>
                      <TableCell component="th" scope="row">
                        {historyRow.date}
                      </TableCell>
                      <TableCell>{historyRow.temperatura}</TableCell>
                      <TableCell align="right">{historyRow.umidade}</TableCell>
                      <TableCell align="right">{historyRow.gases}</TableCell>
                      <TableCell align="right">{historyRow.vento}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

Row.propTypes = {
    row: PropTypes.shape({
      calories: PropTypes.number.isRequired,
      carbs: PropTypes.number.isRequired,
      fat: PropTypes.number.isRequired,
      history: PropTypes.arrayOf(
        PropTypes.shape({
          amount: PropTypes.number.isRequired,
          customerId: PropTypes.string.isRequired,
          date: PropTypes.string.isRequired,
        }),
      ).isRequired,
      name: PropTypes.string.isRequired,
      price: PropTypes.number.isRequired,
      protein: PropTypes.number.isRequired,
    }).isRequired,
};

const rows = [
    createData('Bonfim #Alpha', "-14.010876, -47.561079", "Online"),
    createData('Bonfim #Beta', "-14.010569, -47.561524", "Online"),
    createData('Bonfim #Gama', "-14.034829, -47.580217", "Online"),
    createData('Bonfim #Delta', "-14.045873, -47.543966", "OFF"),
    createData('Bonfim #Épsilon', "-14.067534, -47.561225", "Online"),
    createData('Bonfim #Zeta', "-14.045873, -47.543966", "Online"),
    createData('Bonfim #Eta', "-14.045873, -47.543966", "Online"),
    createData('Bonfim #Teta', "-14.045873, -47.543966", "Online"),
    createData('Bonfim #Iota', "-14.045873, -47.543966", "Online"),
    createData('Bonfim #Capa', "-14.045873, -47.543966", "Online"),
];
  


function ListaSensores() {
    return (
        <div className="sensor-content">
            <TableContainer component={Paper}>
                <Table aria-label="collapsible table">
                    <TableHead>
                    <TableRow>
                        <StyledTableCell />
                        <StyledTableCell>NAME</StyledTableCell>
                        <StyledTableCell>LOCALE</StyledTableCell>
                        <StyledTableCell>STATUS</StyledTableCell>
                        <StyledTableCell>OPEN</StyledTableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                    {rows.map((row) => (
                        <Row key={row.name} row={row} />
                    ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}

export default ListaSensores;